const handleStatusMessage = (statusCode, errorMsg) => {
  if (statusCode.toString() === "404") {
    return "Page not found";
  }
  return errorMsg;
};
export default handleStatusMessage;
